import { ArrowRight } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgRightArrow2 = mkIcon(ArrowRight);